 <div class="mainHotel">
 <div  class="  mt-3 d-flex justify-content-center">
   <div  class="col-md-12 active  pt-2 " style="max-height: 93vh; overflow-y: auto;  ">
    <!-- <div class="col-md-10"> -->
      <span #top class="mt-2"></span>
      <div class="col-md-12 box-container " >
        <div class="col-md-12 container">
  

            <div class="row col-md-12 ">

      <form [formGroup]="searchFg"  class="row">  
  
                          
        <div class="col-md-4 "   style="border-right:1px solid #DEE2E6 ;text-align: left;" >
    
            <mat-label class="col-md-12 bold" style="color:#007bff ;"> Property Name Or Location</mat-label>
            <mat-chip-grid #chipGrid aria-label="Fruit selection">
            </mat-chip-grid>
            <span  class="bold col-md-12" style="font-size: 18px;" >{{hotelName}}, {{departure}}</span>
            
          
  
        </div>
  
        
  
        <div class="col-md-2" style="border-right:1px solid #DEE2E6 ;text-align: left;cursor: pointer" (click)="pickers.open()">
          <mat-label class="col-md-12 bold" style="color:#007bff ;">Check-In</mat-label>
                <input class="mainbox"  style="color: transparent;padding: 0;margin: 0; font-size: 1px;" formControlName="requestedDate" readonly [min]="minData" [matDatepicker]="pickers"   (dateChange)="onOneWayDate()">
              <!-- <div class="col-md-12" >
                <span class=" bold" style="font-size: 35px;">{{departureTime[0]}}</span>&nbsp;&nbsp;<span  style="font-size: 23px;">{{departureTime[1]}}</span><span  style="font-size: 25px;">{{departureTime[2]?("'"+departureTime[2]):''}}</span>
                <br><span class=" bold" style="font-size: 15px; ">{{departureTime[3]}}</span>
              </div> -->
              <div >
                  <span class="bold"> {{departureTime}}</span> 
                 </div>
                <mat-datepicker #pickers ></mat-datepicker>
        </div>
    
        <div class="col-md-2" (click)="picker.open()" style="border-right:1px solid #DEE2E6 ;text-align: left;cursor: pointer">
          <mat-label class="col-md-12 bold" style="color:#007bff ;">Check-Out</mat-label>
  
            <input   style="color: transparent;padding: 0;margin: 0; font-size: 1px;" class="mainbox" readonly [min]="date1Plus(searchFg.value.requestedDate)" [matDatepicker]="picker" formControlName="returnDate" (dateChange)="onRChangeDate()">
            <!-- <div  class="col-md-12">
              <span  class=" bold" style="font-size: 35px;">{{arrivelTime[0]}}</span>&nbsp;&nbsp;<span  style="font-size: 23px;">{{arrivelTime[1]}}</span><span  style="font-size: 25px;">{{arrivelTime[2]?("'"+arrivelTime[2]):''}}</span>
              <br><span class=" bold" style="font-size: 15px; ">{{arrivelTime[3]}}</span>
            </div> -->
            <div >
             <span class="bold"> {{arrivelTime}}</span> 
            </div>
            <div class="bold" *ngIf="!arrivelTime" style="font-size: 12px;">Tap&nbsp;to&nbsp;add&nbsp;a&nbsp;Check-Out&nbsp;date</div>
            <!-- <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle> -->
            <mat-datepicker #picker></mat-datepicker>
            
        </div>
        <div class="col-md-2" style="text-align: left;cursor: pointer;" (click)="SelectDetail()">
          <mat-label class="col-md-12 bold" style="color:#007bff ;">Rooms & Guests</mat-label>
          <span class="d-flex justify-content-start pointer" style="position:relative" > <mat-icon >person</mat-icon>{{room}}&nbsp;{{adult}}&nbsp;{{child}}</span>
  
        </div>
  
          <div class="col-md-2" >
            <button style="width: 100%;height:20px; border-radius: 8px; " mat-raised-button color="accent"  (click)="searchHotel()">
            <!-- <mat-icon >search</mat-icon>  -->
            <span class="bold" style="font-size:xx-large;" >SEARCH</span>
            </button>  
        </div>
       
    </form> 
  
    <div  *ngIf="selectedDetail" class="card shadow col-md-3" style="height:300px; position: absolute ; right:12%;top:12%; z-index: 2;min-width:350px ;" >
      <div>
      <button type="button" class="close" data-dismiss="modal" (click)="closeDetail()">&times;</button>
      </div>

      <div class="room-selection">
        <!-- <h3>Select Rooms</h3> -->
        <!-- Room count dropdown -->
        
        <div class="col-md-12 row">
          <label class="col-md-6 pt-2" for="roomCount">Rooms:</label>
         <div class="col-md-5 styled-select">
          <select   [(ngModel)]="roomCount"  (change)="onRoomCountChange()">
            <option *ngFor="let count of roomOptions" [value]="count">{{ count }}</option>
          </select>
        </div>
        </div>
      
        <!-- Room details for each selected room -->
        <div *ngFor="let room of roomss; let i = index" class="room-detail">
          <h6 class="d-flex justify-content-start">Room {{ i + 1 }}</h6>
          
          <!-- Number of adults -->
          <div class="col-md-12 row">
            <label class="col-md-6 pt-2" for="adults-{{i}}">Adults:</label>
            <div class="col-md-5 styled-select" >
            <select  [(ngModel)]="room.adults" id="adults-{{i}}" (change)="onAdultChange()">
              <option *ngFor="let count of adultOptions"  [value]="count">{{ count }}</option>
            </select>
            </div>
            <!-- <input type="number" [(ngModel)]="room.adults" id="adults-{{i}}" min="1" /> -->
          </div>
      
          <!-- Number of children -->
          <div class="col-md-12 row pt-2 pb-2">
            <label class="col-md-6 " for="children-{{i}}">Children: <br>
              <small style="color: gray; font-size: 10px;">0 - 11 Years Old</small>

            </label>
            
            <!-- <input type="number" [(ngModel)]="room.childrenCount" id="children-{{i}}" min="0" (input)="onChildrenCountChange(i)" /> -->
           <div class="col-md-5 styled-select" >
            <select [(ngModel)]="room.childrenCount" id="children-{{i}}" (change)="onChildrenCountChange(i)">
              <option *ngFor="let count of childOptions" [value]="count">{{ count }}</option>
            </select>
          </div>
          </div>
      
          <!-- Children's ages -->
          <div class="col-md-12 row" *ngIf="room.childrenCount > 0" >
            <!-- <h5>Children's Ages</h5> -->
            <div class="col-md-6" *ngFor="let age of room.childrenAges; let j = index">
              <label for="child-age-{{i}}-{{j}}">Child {{ j + 1 }} Age:</label>
              <div class="styled-select">
              <select [(ngModel)]="room.childrenAges[j]" id="child-age-{{i}}-{{j}}" >
                <option *ngFor="let count of childAgeOptions" [value]="count">{{ count }}</option>
              </select>
            </div>
              <!-- <input type="text" (keypress)="onlyNumberKey($event)" [(ngModel)]="room.childrenAges[j]" id="child-age-{{i}}-{{j}}" min="0" max="11" /> -->
            </div>
          </div>
        </div>
      </div>
      <!-- <div *ngIf="false"  class="row col-md-12 mt-2 d-flex justify-content-center">
        <div class="col-md-4 bold d-flex justify-content-start">Rooms </div>
        <div class="col-md-2" >
        <button (click)="iDecrement()" class="circle-button"> <span class="plus-icon pb-1">-</span></button>
        </div >{{ icurrentNumber }}
        <div class="col-md-2">  
        <button (click)="iIncrement()" class="circle-button">
        <span class="plus-icon pb-1">+</span>
        </button>
        </div>
    </div>
      <div *ngIf="false" class="row col-md-12 mt-2 d-flex justify-content-center">
          <div class="col-md-4 bold d-flex justify-content-start" click >Adults </div>
          <div class="col-md-2 " >
          <button (click)="decrement()" class="circle-button"> <span class="plus-icon pb-1">-</span></button>
          </div >{{ currentNumber }}
          <div class="col-md-2">
          <button (click)="increment()" class="circle-button">
          <span class="plus-icon pb-1">+</span>
          </button>
          </div> 
      </div>
      <div *ngIf="false" class="row col-md-12 mt-2 d-flex justify-content-center">
          <div class="col-md-4 bold " style="text-align: left;">Children <br>
            <small style="color: gray; font-size: 10px;">0 - 11 Years Old</small>
          </div>
          <div class="col-md-2" >
              <button (click)="cDecrement()" class="circle-button"> <span class="plus-icon pb-1">-</span></button>
          </div >{{ ccurrentNumber }}
          <div class="col-md-2">
          <button (click)="cIncrement()" class="circle-button">
              <span class="plus-icon pb-1">+</span>
          </button>
          </div>
      </div>
      
     
      <br>
      <form  [formGroup]="searchFg" class="pb-3" style="background-color: white;padding-left: 4px;">
        <div formArrayName="childrenAges" class="col-md-12 row"> 
          <div class="col-md-6 mt-2" *ngFor="let age of childrenAges.controls; let i = index">
            <input  type="text" (keypress)="onlyNumberKey($event)" class="form-control" [formControlName]="i" min="0" max="11" placeholder="Child age (0-11 years)">
          </div>
        </div>
      </form>
      <br> -->
      
  </div>
  </div>
</div> </div>
<div *ngIf="!propData&&!showPending" class="no-result-container">
  <div class="icon">
    <!-- Use an SVG or FontAwesome icon for the magnifying glass -->
    <!-- <img src="assets/images/" alt="No Result Icon"> -->
  </div>
  <h2>No Result Found</h2>
  <p>We can’t find any item matching your search</p>
</div>
  <span *ngIf="propData&&!showPending">
    <div style="color: rgb(33,33,33);" class="col-md-12" style="padding-top: 12px; padding-left: 20px;" >
        <!-- <img  src="../../../assets/images/hotelroom2.avif" width="100%" height="100%" alt=""> -->
        <div class="col-md-12 row">
        <div class="col-md-8 ">
            <div class="slideshow-container">
         <div *ngFor="let slide of propData.mmtMedia; let i = index" class="mySlides " [style.display]="propData.slideIndex-1 === i ? 'block' : 'none'">
           <div class="numbertext">{{ i + 1 }} / {{ propData.mmtMedia?.length }}</div>
           <img [src]="slide" loading="lazy" style="width:100% ;height:500px;">
            <div class="text">{{ propData?.name }}</div> 
         </div>
         <a class="prev"  (click)="plusSlides(-1,propData)">❮</a>
         <a class="next" (click)="plusSlides(1,propData)">❯</a>
       </div>
    </div>
       <div class="col-md-4 " >
        <div class="col-md-12 row">
         <!-- <div class=" col-md-6 pb-2" *ngFor="let slide of propData.media.hotel[0].images let i = index" (click)="currentSlide(i+1,propData.media.hotel[0])" [class.actives]="propData.media.hotel[0].slideIndex-1 === i">               
           <img [src]="slide?.url" style="width:100% ;cursor: pointer;">

         </div> -->
         <div class=" col-md-6 pb-2" (click)="currentSlide(0+1,propData)" [class.actives]="propData.slideIndex-1 === 0">               
          <img [src]="propData?.mmtMedia[0]" loading="lazy" style="width:100%;height:166px; ;cursor: pointer;">

        </div> 
        <div class=" col-md-6 pb-2"  (click)="currentSlide(1+1,propData)" [class.actives]="propData.slideIndex-1 === 1">               
          <img [src]="propData?.mmtMedia[1]" loading="lazy" style="width:100% ;height:166px;cursor: pointer;">

        </div> 
        <div class=" col-md-6 pb-2" (click)="currentSlide(2+1,propData)" [class.actives]="propData.slideIndex-1 === 2">               
          <img [src]="propData?.mmtMedia[2]" loading="lazy" style="width:100% ;height:166px;cursor: pointer;">

        </div> 
        <div   class=" col-md-6 pb-2"  (click)="currentSlide(3+1,propData)" [class.actives]="propData.slideIndex-1 === 3">               
          <img [src]="propData?.mmtMedia[3]" loading="lazy" style="width:100% ;height:166px;cursor: pointer;">

        </div> 
        <div class=" col-md-6 pb-2"  (click)="currentSlide(4+1,propData)" [class.actives]="propData.slideIndex-1 === 4">               
          <img [src]="propData?.mmtMedia[4]" loading="lazy" style="width:100% ;height:166px;cursor: pointer;">

        </div> 
        <div  class=" col-md-6 pb-2"  (click)="currentSlide(5+1,propData)" [class.actives]="propData.slideIndex-1 === 5">               
          <img  [src]="propData?.mmtMedia[5]" loading="lazy" style="width:100% ;height:166px;cursor: pointer;">

        </div> 
        </div>
       </div>
       
       </div>
 <!-- <div class="bookNow">
        <div class="col-md-12  d-flex justify-content-center">
           <div class="col-md-10 mt-2">
               <img [src]="propData.slides[0]?.img" style="width:100% ;">
               <div class="pt-2"><h4 style="color: #8B5629;">{{propData?.rooms[0]?.name}}</h4></div>
               <div class="col-md-12 row">
               <div class="col-md-7">
                   <small ><mat-icon class="pt-2">people</mat-icon></small>
                   <small *ngIf="searchDetail.adultCount>1"> For {{searchDetail?.adultCount}} Adults</small>
                   <small *ngIf="searchDetail.adultCount===1"> For {{searchDetail?.adultCount}} Adult</small>
                   <small *ngIf="searchDetail.childCount>1"> & {{searchDetail?.adultCount}} Children</small>
                   <small *ngIf="searchDetail.childCount===1"> & {{searchDetail?.adultCount}} Child</small>
                   </div>
                   <div class="col-md-5">
                 
                         
                           <div class=""><small>Per Night </small></div>
                           <div class=""><strong style="font-size:x-large;">₹ {{propData?.rooms[0]?.ratePlans[0]?.price?.basePrice}}</strong></div>
                          <div class=""><small style="white-space: nowrap;">+₹ {{propData?.rooms[0]?.ratePlans[0]?.price?.totalTax}} taxes & fees </small></div>
                       
                   </div>
                   <div> <strong style="color: #007bff;cursor: pointer;" (click)="scroll(rooms)"> VIEW OTHER ROOMS <mat-icon class="pt-2">keyboard_arrow_down</mat-icon></strong></div>
                   <div class="d-flex justify-content-center" style="padding-top: 15px;">
                       <button     mat-flat-button  style=" width: 100%;background-color:#007bff  ;color: white;"  >BOOK THIS NOW</button>
                   </div>
               </div>
       
           </div>
        </div>
          </div> -->



   </div>
   <span #Highlights></span>
   <div  class="sticky-tabs " style="padding-left: 10px; padding-top: 5px;">

    <div  class="tab" style="padding-left: 20px;">
      <div class="row col-md-12">
      <span  class="col-md-10 pt-1  d-flex justify-content-start" style="padding-left: 14px;height: 25px;"><span class="menu-navigation" routerLink="/app/hotel"  > Hotel <span>></span></span> <span class="menu-navigation"(click)="backClick()" >{{ searchDetail?.city}} <span>></span></span><span class="menu-navigation" >{{propData?.name }} <span></span></span> </span>
   <span class="col-md-2" style="height: 25px;" > <span class="back-link"><</span> <a  class="back-link menu-navigation" (click)="backClick()">Back to hotel list</a>
   </span>
    </div>
        <button class="tablinks" (click)="scroll(Highlights)" >Property Highlights</button>
        <button class="tablinks" (click)="scroll(Profile)">Amenities</button>
        <!-- <button class="tablinks" >Reviews</button> -->
        <button class="tablinks" (click)="scroll(location)">Location</button>
        <button class="tablinks" (click)="scroll(rooms)">Suggested Rooms</button>
        <button class="tablinks" (click)="scroll(policies)">Policies</button>

      </div>
   
   </div>
   
   <div   class="col-md-12 mt-4">
   

    <div  class="col-md-12 " style="padding-left: 36px;">
<h4 class="titleHeader">Property Highlights</h4>
<div *ngIf="propData.reviewDetails" class="row col-md-10" style="background-color: rgba(255, 255, 255, 0.857);border-top:1px solid #ddd;border-left:1px solid #ddd; border-right:1px solid #ddd; border-radius: 4px;">
 <div class="col-md-6 pt-3 pb-2" >
  
  <span style="background-color: rgb(31, 99, 202);color: white;padding: 4px; border-radius: 4px;">{{propData?.reviewDetails?.rating}}</span>  <small style="color:rgb(31, 99, 202); font-size: 16px;">&nbsp; ({{propData?.reviewDetails?.totalRatingCount}} Ratings)</small>
 </div> 
 <div class="col-md-6 pt-3 pb-2">
 <!-- <strong class="pt-2" style="border-right:1px solid #ddd ;"> Food</strong>
 <small style="color:#007bff;">&nbsp;(909 Reviews)</small> -->

 </div> 

</div>
<div class=" col-md-10 row" style="background-color: rgba(255, 255, 255, 0.857); border:1px solid #ddd; border-radius: 4px;">
<!-- <div class="col-md-6">
  <li class="pt-2">  200+ couples rated their stay Very Good</li>
  <li class="pt-2">  Perfect for one-night stay!</li>
  <li class="pt-2"> Offers Free Wi-Fi</li>
  <li class="pt-2">  A couple-friendly property (couples who are unmarried and/or have local IDs are welcome)</li>

</div>
<div  class="col-md-6">
  <li class="pt-2">Cleanliness: Rated Very Good by 500+ guests</li>
  <li class="pt-2">Driving to the property? There is free parking service</li>
   <li class="pt-2">Amazing breakfast! Guests like food quality, service and variety</li>
   <span ></span>
</div > -->
<div class="mt-2"><h4>{{ propData?.name }}</h4></div>
<div class="col-md-12 mt-2">
<h6>{{ propData?.address }}</h6></div>
<div class="col-md-12 mt-2"><li><span style="color: #272726; font-size: 15px; font-weight: 700;line-height: 20px;">Pin Code : {{ propData?.pinCode }}</span> </li></div>

<div class="col-md-4 mt-2"><li><span style="color: #272726; font-size: 15px; font-weight: 700;line-height: 20px;">Check In : {{ propData?.checkIn }}</span> </li></div>
  <div class="col-md-4 mt-2"><li><span style="color: #272726; font-size: 15px; font-weight: 700;line-height: 20px;">Check Out : {{ propData?.checkOut }}</span> </li></div>
  <div   class="col-md-12 mt-2" *ngIf="propData?.checkInInstruction"><span style="color: #48504e; font-size: 16px; font-weight: 400;line-height: 26px;" ><strong>Check In Instruction : </strong ><br><span [innerHTML]='propData?.checkInInstruction'></span></span></div>
  <div   class="col-md-12 mt-2" *ngIf="propData?.checkInSpecialInstruction"><span style="color: #48504e; font-size: 16px; font-weight: 400;line-height: 26px;" ><strong>Check In Special Instruction : </strong >{{propData?.checkInSpecialInstruction}}</span></div>

<div   class="col-md-12 mt-2"><span style="color: #48504e; font-size: 20px; font-weight: 400;line-height: 26px;" [innerHTML]="propData?.description"></span></div>

 


</div>
<span #Profile class="mb-4"></span>
<h4 class="mt-4 titleHeader">Amenities
</h4>
<div class="col-md-12 pb-2 pt-2 mt-4 row" style="background-color: rgba(255, 255, 255, 0.857);border-radius: 4px;border:1px solid #ddd;">

      <!-- <div class="amenities-container">
        <div *ngFor="let category of objectKeys(groupedAmenities)" class="category-card">
          <h5 class="category-title">{{ category }}</h5>
          <ul class="amenity-list">
            <li class="amenity-item" *ngFor="let amenity of groupedAmenities[category]">
              <i class="amenity-icon fas fa-check"></i>
              <span class="amenity-name">{{ amenity.displayName }}</span>
            </li>
          </ul>
        </div>
      </div> -->
      <div class="amenities-container">
        <div *ngFor="let category of objectKeys(groupedAmenities); let i = index"  [hidden]=" i >= 15" class="category-card">
          <h5 class="category-title">{{ category }}</h5>
          <ul class="amenity-list">
            <li
              class="amenity-item"
              *ngFor="let amenity of groupedAmenities[category];"
             
            >
              <i class="amenity-icon fas fa-check"></i>
              <span class="amenity-name">{{ amenity.displayName }}</span>
            </li>
          </ul>
          
        </div>
        
      </div>
   
    
   
    
   


</div>
<span class="mb-4" #location></span>
<h4 class="mt-4 titleHeader">Location
</h4>
<div  class="col-md-12 pb-2 pt-2 mt-4 row" style="background-color: rgba(255, 255, 255, 0.857);border-radius: 4px;border:1px solid #ddd;">
    <!-- <h4 class="titleHeader">Location</h4> -->

    <div #mapChr id="mapChr" class=" cards  mt-2 col-md-12 "  >
    
    </div> 

    <!-- <div id="mapChr" class=" cards col-md-12 "  >
    </div>  -->
    <!-- <script src="https://www.google.com/maps/place/Collection+O+Hotel+Bi+Near+Shalimar+Bagh+Metro+Station/@28.6966479,77.1569363,14.85z/data=!4m13!1m2!2m1!1sCollection+O+near+Haiderpur+Metro+Station,+C+and+D+Block,+Shalimar+Place+Site,+Shalimar+Bagh,+Delhi!3m9!1s0x390d031208c0097b:0x7ddd4cc9dbe7ca63!5m2!4m1!1i2!8m2!3d28.702169!4d77.1629921!15sCmNDb2xsZWN0aW9uIE8gbmVhciBIYWlkZXJwdXIgTWV0cm8gU3RhdGlvbiwgQyBhbmQgRCBCbG9jaywgU2hhbGltYXIgUGxhY2UgU2l0ZSwgU2hhbGltYXIgQmFnaCwgRGVsaGlaYSJfY29sbGVjdGlvbiBvIG5lYXIgaGFpZGVycHVyIG1ldHJvIHN0YXRpb24gYyBhbmQgZCBibG9jayBzaGFsaW1hciBwbGFjZSBzaXRlIHNoYWxpbWFyIGJhZ2ggZGVsaGmSAQVob3RlbOABAA!16s%2Fg%2F11px9zqmhz?entry=ttu"></script> -->
    <!-- <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2990.274257380938!2d-70.56068388481569!3d41.45496659976631!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89e52963ac45bbcb%3A0xf05e8d125e82af10!2sDos%20Mas!5e0!3m2!1sen!2sus!4v1671220374408!5m2!1sen!2sus" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> -->

</div>
<span #rooms class="mb-4" ></span>

<h4 class="mt-4 mb-4 titleHeader">Select Rooms
</h4>


<div class="room-container" *ngFor="let room of propData.mmtRooms">
  <h2>{{room?.name}}</h2>

  <div class="room-details">
      <div class="room-images">
        <div class="slideshow-container" >
          <div *ngFor="let slide of room.slides; let i = index" class="mySlides " style="cursor: pointer;" (click)="moreDetails(room)" [style.display]="room.slideIndex-1 === i ? 'block' : 'none'">
            <div class="numbertext">{{ i + 1 }} / {{ room.slides.length }}</div>
            <img [src]="slide?.url" loading="lazy" style="height:250px;">
             <!-- <div class="text">{{ room?.name }}</div>  -->
          </div>
          <a class="prev" (click)="roomSlides(-1,room)">❮</a>
          <a class="next" (click)="roomSlides(1,room)">❯</a>
        </div>
          <a  class="details-link" (click)="moreDetails(room)">Room photos and details</a>
          <!-- <p class="room-size"><i class="icon-size"></i>Room size: 11 m²/118 ft²</p>
          <p class="room-feature"><i class="icon-shower"></i>Shower</p>
          <a href="#" class="facilities-link">See all room facilities</a> -->
          <div class="" *ngIf="room.metadata?.roomSize"><small><mat-icon class="pt-1" > square_foot</mat-icon>&nbsp;{{room?.metadata?.roomSize?(room?.metadata?.roomSize+"sq.ft"):"" }}</small></div> 
          <div class="" *ngFor="let bed of room.metadata?.beds"><small><mat-icon class="pt-1"> hotel</mat-icon>&nbsp;{{bed.type}}</small></div><small style="color: red;" *ngIf="room.metadata.beds.length!=0">(Bed type not guaranteed)</small>
      </div>

      <div class="pricing-options">
          <!-- First Pricing Option -->
          <div class="pricing-option">
            <table class=" ">
              <thead>
                <tr >
                  <!-- Dynamic headers based on tableHeaders array -->
                  
                      <th style="padding: 8px;  text-align: start;width: 35%;">Benefits </th>
                      <th style="padding: 8px;  text-align: start;width: 35%;">Price per night </th>
                      <th style="padding: 8px;  text-align: start;width: 35%;">Booked </th>

                      <!-- <th style="padding: 8px;  text-align: center;width: 30%;">Price </th> -->
      
                  
                </tr>
              </thead>
              <tbody>
                <!-- Iterate through dynamic data rows -->
                <tr *ngFor="let ratePlan of room?.ratePlans" >
                  <!-- Display structured data -->
                  <td class="name-type pricing-card" style="padding: 8px;">
                    <ul style="text-align: start;">
    
                      <li *ngIf="ratePlan?.cancellationPolicy?.cancelPaneltyDesc"><span class="yes"><mat-icon style="padding-top: 5px;font-size: 16px;">star</mat-icon></span>Cancellation policy <mat-icon style="cursor: pointer;color:grey" (click)="op.toggle($event)">info</mat-icon></li>
                      <p-overlayPanel #op [style]="{ width: '30rem' }">
                        <div class="flex flex-column gap-3 w-25rem">
                       
                        <table >
                          <thead>
                              <tr>
                                  <th>Cancellation on or After</th>
                                  <th>Cancellation on or Before</th>
                                  <th>Cancellation Charges/Comments</th>
                              </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let cancellation of ratePlan?.cancellationPolicy?.penalties">
                              <td>{{cancellation?.startDate}}</td>
                              <td>{{cancellation?.endDate}}</td>
                              <td>{{cancellationType(cancellation?.penaltyValue,cancellation?.penaltyType)}}</td>
        
                            </tr>
                             
                          </tbody>
                      </table>
                      
                      <small style="color: green;" *ngFor="let cancellation of cancellationFilter(ratePlan?.cancellationPolicy?.cancelPaneltyDesc)">
                        {{cancellation}}<br>
                      </small>
                      </div>
                      </p-overlayPanel>
                      <li *ngIf="!ratePlan.cancellationPolicy?.cancelPaneltyDesc"><span class="no"><mat-icon style="padding-top: 5px;font-size: 16px;">star</mat-icon></span>Cancellation policy</li>
        
                      <li *ngIf="ratePlan?.inclusions&&ratePlan?.inclusions?.length!=0"><span  class="yes"><mat-icon style="padding-top: 5px;font-size: 16px;">star</mat-icon></span>  Meal plan <mat-icon style="cursor: pointer;color:grey" (click)="meal.toggle($event)">info</mat-icon>   
                      </li>
                      <li *ngIf="!ratePlan?.inclusions||ratePlan?.inclusions?.length===0"><span  class="no"><mat-icon style="padding-top: 5px;font-size: 16px;">star</mat-icon></span>Meal plan</li>
                      <p-overlayPanel #meal [style]="{ width: '30rem' }">
                        <div class="flex flex-column gap-3 w-25rem">
                          <small style="color: rgb(99, 99, 99);" *ngFor="let inclusions of ratePlan?.inclusions ">
                            {{inclusions?.name}}<br>
                         </small></div>
                      </p-overlayPanel>
                  </ul>
      
                  </td>
                  <td class="" style="padding: 8px;">
                    <div class="price">
                      <!-- <span class="discount">SAVE 56% TODAY!</span> -->
                      <p class="old-price">{{ratePlan?.description }}</p>
                      <!-- <p class="new-price">₹{{ratePlan?.price?.basePrice+ratePlan?.totalAmount}}</p> -->

                      <p class="new-price" style="white-space: nowrap;">₹{{ratePlan?.totalAmount+(ratePlan?.commercial?.markup?(ratePlan?.commercial?.markup):0)}}&nbsp;<mat-icon style="cursor: pointer;color:grey" (click)="totalmmtDetail.toggle($event)">info</mat-icon></p>
                      <p class="price-info">
                                                &nbsp;&nbsp;&nbsp;&nbsp;
                        <!-- Per night before taxes and fees -->
                      </p>
                  </div>
                  <p-overlayPanel #totalmmtDetail [style]="{ width: '30rem' }">
                    <div class="flex flex-column gap-3 w-25rem">

                    <table >
                      
                      <tbody>
                        <tr >
                          <th>Base Fare</th>
                          <td>{{(mmtBaseFare(ratePlan?.price?.basePrice,ratePlan?.price?.couponDiscount,ratePlan?.price?.hotelDiscount)+(ratePlan?.commercial?.charge?(ratePlan?.commercial?.markup):0))||0}}&nbsp;INR</td>
                           </tr>
                           <tr >
                            <th>Taxes & fees</th>
                            <td>{{ratePlan?.price?.totalTax||0}}&nbsp;INR</td>
                          </tr>
                        
                        <tr>
                          <th>MGMT FEE + GST </th>
                          <td>{{ratePlan?.commercial?.charge?(ratePlan?.commercial?.charge?.toFixed()):0}} + {{ratePlan?.commercial?.tax?(ratePlan?.commercial?.tax?.toFixed()):0}}&nbsp;INR</td>
                        </tr>
                        <tr >
                          <th>Total Fare</th>
                          <td class="bold"> {{ratePlan?.totalAmount+(ratePlan?.commercial?.markup?(ratePlan?.commercial?.markup):0)||0}}&nbsp;INR</td>
                        </tr>
                         
                      </tbody>
                  </table>
                  
                    </div> 
                  </p-overlayPanel>
                  </td>
                  <td class="" style="padding: 8px;">
                    <div class="booking" *ngIf="tripEnable===false">
                      <button *ngIf="!showSpiner" class="book-now" (click)="OnClickSelectRoom(room,ratePlan)">Book&nbsp;now</button>
                      <button  *ngIf="showSpiner" disabled  mat-raised-button color="accent" style="margin-right: 2%; width: 100px;"  >Book&nbsp;now</button>

                      <!-- <button class="add-to-cart">Add to cart</button> -->
                      <!-- <p class="availability">Limited availability</p> -->
                  </div>
                  <div class="booking" *ngIf="tripEnable===true">
                    <button *ngIf="!showSpiner" class="book-now" (click)="OnClickSelectRoom(room,ratePlan)">Select</button>
                    <button  *ngIf="showSpiner" disabled  mat-raised-button color="accent" style="margin-right: 2%; width: 100px;"  >Select</button>

                    <!-- <button class="add-to-cart">Add to cart</button> -->
                    <!-- <p class="availability">Limited availability</p> -->
                </div>
                  </td>
                </tr>
              </tbody>
            </table>

<!--             
              <div class="benefits">
                  <p>Your price includes:</p>
                  <ul>
                      <li><i class="icon-check"></i>Cancellation policy</li>
                      <li><i class="icon-check"></i>Express check-in, Free WiFi</li>
                  </ul>
              </div>
              <div class="sleeps">
                  <i class="icon-person"></i><i class="icon-person"></i>
              </div>
              <div class="price">
                  <span class="discount">SAVE 56% TODAY!</span>
                  <p class="old-price">Rs. 17,210</p>
                  <p class="new-price"> Rs. 17,210</p>
                  <p class="price-info">Per night before taxes and fees</p>
              </div>
              <div class="booking">
                  <button class="book-now">Book Now</button>
                  <button class="add-to-cart">Add to cart</button>
                  <p class="availability">Limited availability</p>
              </div> -->
          </div>

      </div>
  </div>
</div>



<div class="room-container" *ngFor="let room of propData.expediaRooms">
  <h2>{{room?.room_name}}</h2>

  <div class="room-details">
      <div class="room-images">
        <div class="slideshow-container" >
          <!-- (click)="moreDetails(room)" -->
          <div *ngFor="let slide of room.slides; let i = index" class="mySlides " style="cursor: pointer;"  [style.display]="room.slideIndex-1 === i ? 'block' : 'none'">
            <div class="numbertext">{{ i + 1 }} / {{ room.slides.length }}</div>
            <img  [src]="slide?.url" loading="lazy" style="height:250px;">

             <!-- <div class="text">{{ room?.name }}</div>  -->
          </div>
          <div  *ngIf="room.slides.length===0" class="mySlides " style="cursor: pointer;"  [style.display]="room.slideIndex-1 === 0 ? 'block' : 'none'" >

          <img  src="../../../assets/images/default.png" loading="lazy" style="height:250px;">
</div>
          <a *ngIf="room.slides.length!=0" class="prev" (click)="roomSlides(-1,room)">❮</a>
          <a *ngIf="room.slides.length!=0" class="next" (click)="roomSlides(1,room)">❯</a>
        </div>
          <!-- <a  class="details-link" (click)="moreDetails(room)">Room photos and details</a> -->
          <!-- <p class="room-size"><i class="icon-size"></i>Room size: 11 m²/118 ft²</p>
          <p class="room-feature"><i class="icon-shower"></i>Shower</p>
          <a href="#" class="facilities-link">See all room facilities</a> -->

          <div class="" *ngIf="room?.metadata?.area"><small><mat-icon class="pt-1" > square_foot</mat-icon>&nbsp;{{room?.metadata?.area.square_meters?(room?.metadata?.area?.square_meters?(room?.metadata?.area?.square_meters+'sq.mtr'):room?.metadata?.area?.square_feet?(room?.metadata?.area?.square_feet+'sq.ft'):''):"" }}</small></div> 
          <!-- <div class="" *ngIf="room?.images?.bed_groups[0]?.id"><small><mat-icon class="pt-1"> hotel</mat-icon>&nbsp;{{room?.images?.bed_groups[0]?.id}} </small></div> -->
          <div class="" *ngIf="room?.metadata?.bed_groups[0]?.id"><small><mat-icon class="pt-1"> hotel</mat-icon>&nbsp;{{room?.metadata?.bed_groups[0]?.id?(room?.metadata?.bed_groups[0]?.id):''}} </small><small style="color: red;">(Bed type not guaranteed)</small></div>

          
      </div>

      <div class="pricing-options">
          <!-- First Pricing Option -->
          <div class="pricing-option">
            <table class=" ">
              <thead>
                <tr >
                  <!-- Dynamic headers based on tableHeaders array -->
                  
                      <th style="padding: 8px;  text-align: start;width: 35%;">Benefits </th>
                      <th style="padding: 8px;  text-align: start;width: 35%;">Price per night </th>
                      <th style="padding: 8px;  text-align: start;width: 35%;">Booked </th>

                      <!-- <th style="padding: 8px;  text-align: center;width: 30%;">Price </th> -->
      
                  
                </tr>
              </thead>
              <tbody>
                <!-- Iterate through dynamic data rows -->
                <tr *ngFor="let ratePlan of room?.rates" >
                  <!-- Display structured data -->
                  <td class="name-type pricing-card" style="padding: 8px;">

                    <ul style="text-align: start;">
    
                      <li *ngIf="ratePlan?.cancel_penalties && ratePlan?.cancel_penalties.length>0"><span class="yes"><mat-icon style="padding-top: 5px;font-size: 16px;">star</mat-icon></span> Cancellation policy <mat-icon style="cursor: pointer;color: grey;" (click)="op.toggle($event)">info</mat-icon></li>
                      <p-overlayPanel #op [style]="{ width: '30rem' }">
                        <div class="flex flex-column gap-3 w-25rem">
                       
                        <table >
                          <thead>
                              <tr>
                                  <th>Cancellation on or After</th>
                                  <th>Cancellation on or Before</th>
                                  <th>Cancellation Charges/Comments</th>
                              </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let cancellation of ratePlan?.cancel_penalties">
                              <td>{{dateFormateTime(cancellation?.start)}}</td>
                              <td>{{dateFormateTime(cancellation?.end)}}</td>
                              <td *ngIf="cancellation?.amount">{{cancellation?.amount||0}}{{cancellation?.currency||'INR'}}</td>
                              <td *ngIf="cancellation?.nights">{{cancellation?.nights||0}} Night</td>
                              <td *ngIf="cancellation?.percent">{{cancellation?.percent||0}} %</td>

                            </tr>
                             
                          </tbody>
                      </table>
                      <small style="color: green;font-style: italic;">All times are in the local time zone</small>
                      <!-- <small style="color: green;" *ngFor="let cancellation of cancellationFilter(ratePlan?.cancellationPolicy?.cancelPaneltyDesc)">
                        {{cancellation}}<br>
                      </small> -->
                      </div>

                      </p-overlayPanel>
                      <li *ngIf="!ratePlan?.cancel_penalties&&ratePlan?.cancel_penalties.length===0"><span class="no"><mat-icon style="padding-top: 5px;font-size: 16px;">star</mat-icon></span>Cancellation policy </li>
        
                      <li *ngIf="ratePlan.refundable"><span  class="yes"><mat-icon style="padding-top: 5px;font-size: 16px;">star</mat-icon></span> Refundable    
                      </li>
                      <li *ngIf="!ratePlan.refundable"><span  class="no"><mat-icon style="padding-top: 5px;font-size: 16px;">star</mat-icon></span>Non Refundable</li>
                      <!-- <p-overlayPanel  [style]="{ width: '30rem' }">
                        <div class="flex flex-column gap-3 w-25rem">
                          <small style="color: rgb(99, 99, 99);" *ngFor="let inclusions of ratePlan?.inclusions ">
                            {{inclusions?.name}}<br>
                         </small></div>
                      </p-overlayPanel> -->
                      <li  *ngFor="let amen of ratePlan.amenities let t = index"  [hidden]=" t >= 3"> 
                        <!-- <mat-icon style="font-size: 18px;padding-top: 3px;"  *ngIf="amen.name==='Free WiFi'">wifi</mat-icon>
                        <mat-icon style="font-size: 18px;padding-top: 3px;"  *ngIf="amen.name==='Free self parking'"> local_parking</mat-icon>
                        <mat-icon style="font-size: 18px;padding-top: 3px;" *ngIf="amen.name==='Breakfast buffet'">free_breakfast</mat-icon>
                        <mat-icon style="font-size: 18px;padding-top: 3px;" *ngIf="amen.name==='Free one-way airport transfer'"> transfer_within_a_station</mat-icon>
                        <mat-icon style="font-size: 18px;padding-top: 3px;" *ngIf="amen.name==='Free welcome drink'"> local_drink</mat-icon> -->

                        <span style="width:10px;height:5px;background-color: grey;width:4px;border-radius:10px ;"></span> {{amen.name }}

                      </li>
                      
                      <li *ngIf="ratePlan.amenities&&ratePlan.amenities.length>3"><span  class="yes" style="cursor: pointer;" (click)="ameni.toggle($event)">...more</span></li>

                      <p-overlayPanel #ameni [style]="{ width: '30rem' }">
                        <li *ngFor="let amen of ratePlan.amenities "  > 
                          {{ amen.name }}
                        </li>
                  </p-overlayPanel>
                  </ul>
                  
                  </td>
                  <td class="" style="padding: 8px;">
                    <div class="price">

                      <!-- <span class="discount">SAVE 56% TODAY!</span> -->
                      <p class="old-price">{{ratePlan?.description }}</p>
                      <!-- <p class="new-price">₹{{ratePlan?.price?.basePrice+ratePlan?.totalAmount}}</p> -->
                     <p class="stamp-container ">
                      <span  *ngIf="ratePlan?.sale_scenario?.corporate===true&&loginUserType==='STAFF'" class="business-tab">
                        Business&nbsp;Friendly
                      </span>
                     </p>
                      <p class="new-price" style="white-space: nowrap;">{{(ratePlan?.totalPrice?.requestedCurrencyTotalPrice+(ratePlan?.commercial?.markup?(ratePlan?.commercial?.markup):0))?.toFixed()||0}}&nbsp;INR&nbsp;<mat-icon style="cursor: pointer;color:grey" (click)="totalDetail.toggle($event)">info</mat-icon></p>
                      <p *ngIf="ratePlan?.sale_scenario?.package===true&&loginUserType==='STAFF'" class="stamp-container ">
                        <button disabled class="stamp-button">Special Rate</button>
                      </p>
                      <p class="price-info">
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <!-- Per night before taxes and fees -->
                      </p>
                  </div>
                  <p-overlayPanel #totalDetail [style]="{ width: '30rem' }">
                    <div class="flex flex-column gap-3 w-25rem">

                    <table >
                      
                      <tbody>
                        <tr >
                          <th>Base Fare</th>
                          <td>{{(ratePlan?.totalPrice?.exclusive?.request_currency?.value+(ratePlan?.commercial?.markup?(ratePlan?.commercial?.markup):0)).toFixed()}}&nbsp;{{ratePlan?.totalPrice?.exclusive?.request_currency?.currency||'INR'}}</td>
                           </tr>
                           <tr >
                            <th>Taxes & fees</th>
                            <td>{{(ratePlan?.totalPrice?.inclusive?.request_currency?.value-ratePlan?.totalPrice?.exclusive?.request_currency?.value)?.toFixed()||0}} &nbsp;{{ratePlan?.totalPrice?.marketing_fee?.request_currency?.currency||'INR'}} &nbsp;<mat-icon style="cursor: pointer;color:grey;padding-top: 8px;font-size: 18px;" (click)="text.toggle($event)">info</mat-icon>
                              <p-overlayPanel #text [style]="{ width: '30rem' }">
                                <div class="flex flex-column gap-3 w-25rem">
                                  This charge includes estimated amounts the travel service provider (i.e. hotel, car rental company) pays for their taxes, and/or taxes that we pay, to taxing authorities on your booking (including but not limited to sales, occupancy, and value added tax). This amount may also include any amounts charged to us for resort fees, cleaning fees, and other fees and/or a fee we, the hotel supplier and/or the site you booked on, retain as part of the compensation for our and/or their services, which varies based on factors such as location, the amount, and how you booked.For more details, please see the <a href="https://developer.expediapartnersolutions.com/terms/en" target="_blank"> terms and conditions.</a>
                                </div>
                                  </p-overlayPanel>
                            </td>
                          </tr>
                        <tr >
                          <th>property Fee</th>
                          <td>{{ratePlan?.totalPrice?.property_fees?.request_currency?.value?.toFixed()||0}}&nbsp;{{ratePlan?.totalPrice?.marketing_fee?.request_currency?.currency||'INR'}}</td>
                        </tr>
                        <tr>
                          <th>Affiliate Service Charge + GST </th>
                          <td>{{ratePlan?.commercial?.charge?(ratePlan?.commercial?.charge?.toFixed()):0}} + {{ratePlan?.commercial?.tax?(ratePlan?.commercial?.tax?.toFixed()):0}} INR</td>
                        </tr>
                        <tr >
                          <th>Total Fare</th>
                          <td class="bold"> {{(ratePlan?.totalPrice?.requestedCurrencyTotalPrice+(ratePlan?.commercial?.markup?(ratePlan?.commercial?.markup):0))?.toFixed()||0}}&nbsp;INR</td>
                        </tr>
                         
                      </tbody>
                  </table>
                  
                    </div> 
                  </p-overlayPanel>
                  </td>
                  <td class="" style="padding: 8px;">
                    <div class="booking" *ngIf="tripEnable===false">
                      <button *ngIf="!showSpiner" class="book-now" (click)="getExpediaPrice(room,ratePlan)">Book&nbsp;now</button>
                      <button  *ngIf="showSpiner" disabled  mat-raised-button color="accent" style="margin-right: 2%; width: 100px;"  >Book&nbsp;now</button>

                      <!-- <button class="add-to-cart">Add to cart</button> -->
                      <!-- <p class="availability">Limited availability</p> -->
                  </div>
                  <div class="booking" *ngIf="tripEnable===true">
                    <button *ngIf="!showSpiner" class="book-now" (click)="getExpediaPrice(room,ratePlan)">Select</button>
                    <button  *ngIf="showSpiner" disabled  mat-raised-button color="accent" style="margin-right: 2%; width: 100px;"  >Select</button>

                   
                </div>
                  </td>
                </tr>
              </tbody>
            </table>


          </div>

      </div>
  </div>
</div>









<!-- ######################## -->



<span #policies></span>
<h4 class="mt-4 titleHeader">Policies
</h4>
<div  class="col-md-12 pb-2 pt-2 mt-4 row" style="background-color: rgba(255, 255, 255, 0.857);border-radius: 4px;border:1px solid #ddd;">

  <!-- <h4 class="pt-2 titleHeader">Policies</h4> -->

 
  <div class="amenities-container">

  <div *ngFor="let policy of propData.mmtPolicies" class="policy-card">
    <h5 class="category-title" style="color: rgb(99, 99, 99);">{{ policy?.category }}</h5>
    <ul  class="amenity-list">
      <li class="amenity-item"  *ngFor="let policyList of policy.policyList">
        <i class="amenity-icon fas fa-check"></i>
        <span class="amenity-name" > {{ policyList }}</span>

       
      </li>
    </ul>
  </div>
</div>

</div>
   </div>



   
</div>
<button    *ngIf="propData"
(click)="scroll(top)"  style="background-color: rgb(6, 141, 146);color: white; position: sticky;bottom:0 ;left:100%"   mat-fab><mat-icon style="margin-left: 3px;">expand_less</mat-icon></button>
</span>
</div>
</div>

<div>
    <div class="modal" id="myMod" [style.display]="popup ? 'block' : 'none'" [ngClass]="{ 'open': popup }" >
        <div class="modal-dialog" >
            <div class="modal-content " >
                <div class="modal-header title">
                  <h4 *ngIf="popup" class="modal-title">{{popupData?.name}}
                  </h4>
                  <button *ngIf="popup" type="button" class="close" data-dismiss="modal" (click)="closePopup()">&times;</button>

                  </div>
                  <div class="modal-body"  style="overflow: auto; max-height: 50vh;" *ngIf="popup">
                    <div class="slideshow-container" >
                        <div *ngFor="let slide of popupData.slides; let i = index" class="mySlides " (click)="moreDetails(popupData)" [style.display]="popupData.slideIndex-1 === i ? 'block' : 'none'">
                          <div class="numbertext">{{ i + 1 }} / {{ popupData.slides.length }}</div>
                          <img [src]="slide?.url" loading="lazy" style="width:100% ;height:290px;">
                           <!-- <div class="text">{{ room?.name }}</div>  -->
                        </div>
                        <a class="prev" (click)="roomSlides(-1,popupData)">❮</a>
                        <a class="next" (click)="roomSlides(1,popupData)">❯</a>
                      </div>
                      <div *ngIf="popupData.metadata.roomSize" class=""><small><mat-icon class="pt-1" > square_foot</mat-icon>&nbsp;{{popupData?.metadata?.roomSize?(popupData?.metadata?.roomSize+"sq.ft"):"" }}</small></div> 
                      <div class="" *ngFor="let bed of popupData.metadata.beds"><small><mat-icon class="pt-1"> hotel</mat-icon>{{bed.type}}</small></div>&nbsp;<small style="color: red;" *ngIf="popupData.metadata.beds.length!=0">(Bed type not guaranteed)</small>
                </div>

                  <div class="modal-footer">
                    <div class="form-group form-inline ">
                      <label for="userName" class="col-md-5 col-form-label control-label"> </label>
                    </div>   
                      <button type="button" class="btn btn-outline-primary c-width-100px shadow" data-dismiss="modal" (click)="closePopup()">Close</button>
                 
                  </div>

                 

          </div>
      </div>
    </div>
<!--###################################  pendingFlight.gif ##################################################
     ################################### pendingFlight.gif  ################################################## 
      ################################### pendingFlight.gif ##################################################-->
      <div *ngIf="showPending" >
        <div class="gif-container">
          <img src="../../../assets/images/image_processing20210217-16671-11ezcsw.gif" >
      </div>
      </div>
     